export const LOCAL_STORAGE_AUTH_TOKEN = 'accessToken';
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken';
export const LOCAL_STORAGE_LESSON_STEPS_VIEW = 'lessonStepsView';
